import { useFeatureFlagPayload } from 'posthog-js/react';
import type { PostHogFeatureFlags } from '@lib/posthog-feature-flags';

/**
 * Read the JSON payload attached to a PostHog feature flag.
 *
 * Use this for flags that carry a value (a banner message, a mocked number)
 * rather than a plain on/off switch; those belong with
 * `usePostHogFeatureFlag`.
 *
 * Returns the supplied default while PostHog is still loading flags on the
 * client, when PostHog is not configured (e.g. local development or Cypress
 * without the env vars set), and when the flag is off or has no payload, so
 * consumers never observe an `undefined` state.
 */
export const usePostHogFeatureFlagPayload = <PayloadType>(
  flag: PostHogFeatureFlags,
  defaultValue: PayloadType
): PayloadType => {
  const payload = useFeatureFlagPayload(flag) as PayloadType | undefined;
  return payload ?? defaultValue;
};
